import { useEffect, useState } from "preact/hooks";
import { calculateGiftsThatGiveGoal } from "@/util/common.js";

const useGiftsThatGive = ({ goal }) => {
  const [giftsThatGiveEffectAmount, setGiftsThatGiveEffectAmount] = useState(0);
  useEffect(() => {
    setGiftsThatGiveEffectAmount(calculateGiftsThatGiveGoal(goal));
  }, [goal]);

  return giftsThatGiveEffectAmount;
};

export default useGiftsThatGive;
